const app = {
  ...window.app,

  animation: {
    lottie: {
      anims: {},
    
      init: function () {
        const _this = this;
        if (typeof lottie === 'undefined') return;

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const animData = _this.anims[entry.target.id];
              if (!animData) return;
    
              const { anim, playOnHover } = animData;
              if (entry.intersectionRatio >= 0.7) {
                if (!playOnHover) {
                  anim.loop = true;
                  anim.play();
                }
              } else {
                anim.pause();
              }
            });
          },
          { threshold: [0.7] }
        );
    
        // Initialize animations
        window.bpLottie?.forEach((animation) => {
          const params = animation.params;
          if (!document.body.contains(params.container)) return;

          const anim = lottie.loadAnimation(params);
          _this.anims[params.container.id] = {
            anim: anim,
            playOnHover: params.playOnHover || false,
          };
    
          if (params.playOnHover) {
            const hoverElement = params.playOnHoverEl ? params.container.closest(params.playOnHoverEl) : params.container;
    
            hoverElement?.addEventListener('mouseenter', () => {
              anim.loop = true;
              anim.play();
            });
    
            hoverElement?.addEventListener('mouseleave', () => {
              anim.loop = false;
            });
          } else {
            observer.observe(params.container);
          }
        });
      },
    },  

    typing: {
      els: document.querySelectorAll('.mt-anim-typing'),
      config: {
        typingSpeed: 100,
        waitTime: 1500
      },

      init: function() {
        const _this = this;
        if (_this.els.length == 0) return;

        _this.els.forEach(container => {
          const sentences = container.getAttribute('data-text').split(';').map(sentence => sentence.trim());
          let currentSentenceIndex = 0;
          let isTyping = false;

          const typeNextLetter = () => {
            const currentSentence = sentences[currentSentenceIndex];
            const currentSentenceLength = currentSentence.length;
            let currentLetterIndex = container.textContent.length;

            if (isTyping) {
              if (currentLetterIndex < currentSentenceLength) {
                container.textContent = currentSentence.slice(0, currentLetterIndex + 1);
                currentLetterIndex++;
                setTimeout(typeNextLetter, _this.config.typingSpeed);
              } else {
                isTyping = false;
                setTimeout(eraseSentence, _this.config.waitTime);
              }
            } else {
              if (currentLetterIndex > 0) {
                container.textContent = container.textContent.slice(0, currentLetterIndex - 1);
                currentLetterIndex--;
                setTimeout(typeNextLetter, _this.config.typingSpeed);
              } else {
                isTyping = true;
                currentSentenceIndex = (currentSentenceIndex + 1) % sentences.length;
                currentLetterIndex = 0;
                setTimeout(typeNextLetter, _this.config.typingSpeed);
              }
            }
          };

          const eraseSentence = () => {
            setTimeout(() => {
              isTyping = false;
              typeNextLetter();
            }, _this.config.waitTime);
          };

          typeNextLetter();
        });
      }
    },

    rotatingText: {
      els: document.querySelectorAll('.mt-anim-rotating-text'),

      init: function() {
        const _this = this;
        if (_this.els.length == 0) return;

        _this.els.forEach(container => {
          const swiper = new Swiper(container, {
            slidesPerView: 1,
            spaceBetween: 0,
            direction: 'vertical',
            speed: 600,
            allowTouchMove: false,
            autoplay: {
              delay: 600,
            },
            loop: true
          });
        });
      }
    },

    init: function() {
      const _this = this;
      _this.typing.init();
      _this.rotatingText.init();
      _this.lottie.init();
    }
  },

  form: {
    quantity: function () {
      window.addEventListener('click', e => {
        if (e.target.classList.contains('mt-quantity__button')) {
          const button = e.target;
          const input = button.parentElement.querySelector('.mt-quantity__input');
          let quantity = Number(input.value);

          if (button.dataset.action === 'decrease') {
            input.value = (quantity - 1 >= 0) ? quantity - 1 : 0;
          } else {
            const inputMax = input.max || 20;
            input.value = (quantity + 1 <= inputMax) ? quantity + 1 : 20;
          }

          input.dispatchEvent(new Event('change'));
        }
      });
    },

    init: function () {
      this.quantity();
    }
  },

  prefetch: {
    init: function() {
      const supportedLinks = ['/products/', '/pages/soccer', '/pages/basketball', '/pages/tennis', '/pages/martial-arts', '/pages/physiotherapy', '/pages/fitness', '/pages/reactive-intelligence', '/pages/experience', '/collections/shop-page', '/pages/athlete', '/pages/coach', '/pages/young-athletes', '/pages/physical-therapist', '/pages/fitness-athlete'];
      supportedLinks.forEach(linkPart => {
        const links = document.querySelectorAll(`a[href*="${linkPart}"]`);
        links.forEach(link => {
          const prefetchResource = () => {
            const prefetchLink = document.createElement('link');
            prefetchLink.rel = 'prefetch';
            prefetchLink.href = link.href;
            prefetchLink.fetchPriority = 'high';
            prefetchLink.as = 'document';
            document.head.appendChild(prefetchLink);
          };
          link.addEventListener('mouseenter', prefetchResource, { once: true });
          link.addEventListener('touchstart', prefetchResource, { once: true });
        });
      });
    }
  },

  productForm: {
    forms: document.querySelectorAll('.mt-product-form:not([data-events="true"])'),
    cartUrl: window.Shopify.routes.root + 'cart',

    init: function () {
      const _this = this;
      _this.forms = document.querySelectorAll('.mt-product-form:not([data-events="true"])');

      if (_this.forms.length === 0) return;

      _this.forms.forEach(form => {
        const miniCart = document.querySelector('.mt-mini-cart');
        const productPage = form.closest('.mt-product');
        const fields = {
          id: form.querySelector('[name="id"]'),
          quantity: form.querySelector('[name="quantity"]'),
          sellingPlan: form.querySelector('[name="selling_plan"]'),
          button: form.querySelector('button[type="submit"]')
        };
        const isUnique = (form.dataset.unique == 'true');
        let stickyProductForm = null;
        let additionalOffer = null;

        // PDP additional offer
        if (productPage !== null) {
          additionalOffer = {
            section: productPage.querySelectorAll('.mt-form-offer:not([data-events="true"])'),
            image: productPage.querySelectorAll('.mt-form-offer__logo'),
            checkbox: productPage.querySelectorAll('.mt-form-offer__checkbox input'),
            button: productPage.querySelectorAll('.mt-form-offer__btn')
          };
          stickyProductForm = productPage.querySelector('.mt-sticky-product-form .mt-btn');
          if (additionalOffer.section && additionalOffer.checkbox.length > 0) {
            additionalOffer.checkbox.forEach(offerCheckbox => {
              const offer = offerCheckbox.closest('.mt-form-offer');
              offerCheckbox.addEventListener('change', e => {
                e.preventDefault();
                offer.dataset.offerActive = offerCheckbox.checked;
                window.app.productPage.updatePrice();
              });
            });
            additionalOffer.button.forEach(offerButton => { 
              const offerCheckbox = offerButton.closest('.mt-form-offer').querySelector('.mt-form-offer__checkbox input');
              if (!offerCheckbox) return;
              offerButton.addEventListener('click', e => {
                e.preventDefault();
                offerCheckbox.checked = !offerCheckbox.checked;
                offerCheckbox.dispatchEvent(new Event('change'));
              })
            });
            additionalOffer.image.forEach(offerImage => {
              const offerCheckbox = offerImage.closest('.mt-form-offer').querySelector('.mt-form-offer__checkbox input');
              offerImage.addEventListener('click', () => {
                offerCheckbox.checked = !offerCheckbox.checked;
                offerCheckbox.dispatchEvent(new Event('change'));
              });
            });
            additionalOffer.section.forEach(section => (section.dataset.events = 'true'));
          }
        }

        // Main ATC form
        form.addEventListener('submit', e => {
          e.preventDefault();
          e.stopPropagation();

          const additionalProducts = [];
          const formData = { items: [] };
          const bundleId = Math.random().toString(36).slice(2, 7);
          const bundleIdQ = Math.random().toString(36).slice(2, 7);
          let isBundle = false;

          if (fields.id === undefined) return;

          // LP Flow
          if (form.classList.contains('mt-lp-form')) {
            fields.id = form.querySelector('[name="id"]:checked');

            const optionGroups = form.querySelectorAll('.mt-product-option__list');
            if (optionGroups.length > 0) {
              let isValid = true;
              optionGroups.forEach(optionGroup => {
                const error = optionGroup.querySelector('.mt-product-option__error');
                const options = optionGroup.querySelectorAll('.mt-product-option__item input');
                const selectedOption = [...options].find(o => o.checked);
                if (!selectedOption && error) {
                  isValid = false;
                  error.classList.add('visible');
                  error.setAttribute('aria-hidden', false);
                  options.forEach(option => {
                    option.addEventListener('change', () => {
                      error.classList.remove('visible');
                      error.setAttribute('aria-hidden', true);
                    }, { once: true });
                  })
                }
              });
              if (!isValid) {
                form.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
                return;
              }
            }
          }

          // Disable ATC button
          if (fields.button !== null) {
            fields.button.disabled = true;
            fields.button.classList.add('mt-btn--loading');
          }

          // Additional required items
          if (window.app.cartConnections && window.app.cartConnections.length > 0) {
            const productGroupArr = window.app.cartConnections.filter(group => group.products_id_list.includes(Number(fields.id.dataset.productId)));
            if (productGroupArr.length > 0) {
              productGroupArr.forEach(productGroup => {
                additionalProducts.push({
                  id: productGroup.product_variant_id,
                  quantity: Number(fields.quantity.value),
                  selling_plan: productGroup.product_selling_plan,
                  properties: {
                    _bundleId: `#${bundleId}`,
                    _bundleIdQ: `#${bundleIdQ}`,
                    _sellingPlan: productGroup.product_selling_plan,
                    _itemEditable: false,
                    _itemRemovable: false
                  }
                });
              });
              isBundle = true;
            }
          }

          // Additional PDP offer
          if (additionalOffer !== null && additionalOffer.checkbox.length > 0) {
            additionalOffer.checkbox.forEach(offerCheckbox => {
              if (!offerCheckbox.checked) return;
              if (offerCheckbox.dataset.upsell === 'true') {
                additionalProducts.push({
                  id: Number(offerCheckbox.dataset.variant),
                  quantity: 1,
                  selling_plan: offerCheckbox.dataset.sellingPlan ? Number(offerCheckbox.dataset.sellingPlan) : null,
                  properties: {
                    _sellingPlan: offerCheckbox.dataset.sellingPlan ? Number(offerCheckbox.dataset.sellingPlan) : null,
                    _itemEditable: true,
                    _itemRemovable: offerCheckbox.dataset.removable,
                    _upsell: 'pdp_addon'
                  }
                });
              } else {
                additionalProducts.push({
                  id: Number(offerCheckbox.dataset.variant),
                  quantity: 1,
                  selling_plan: offerCheckbox.dataset.sellingPlan ? Number(offerCheckbox.dataset.sellingPlan) : null,
                  properties: {
                    _bundleId: `#${bundleId}`,
                    _bundleIdQ: `#${bundleIdQ}`,
                    _sellingPlan: offerCheckbox.dataset.sellingPlan ? Number(offerCheckbox.dataset.sellingPlan) : null,
                    _itemEditable: false,
                    _itemRemovable: offerCheckbox.dataset.removable,
                    _upsell: 'pdp_addon'
                  }
                });
                isBundle = true;
              }
            });
          }

          // Prepare formData
          let productData = {
            id: Number(fields.id.value),
            quantity: Number(fields.quantity.value),
            selling_plan: fields.sellingPlan?.value ? Number(fields.sellingPlan.value) : null,
            properties: {}
          };
          isBundle && (productData.properties = {
            ...productData.properties,
            _bundleId: `#${bundleId}`,
            _itemType: 'product-main'
          });
          isUnique && (productData.properties = {
            ...productData.properties,
            _uId: `#${Math.random().toString(36).slice(2, 7)}`,
            _itemEditable: false
          });
          (additionalProducts.length > 0) && additionalProducts.forEach(product => formData.items.push(product));
          formData.items.push(productData);
          
          // Prepare DataLayer products
          const productsToAdd = [fields.id.dataset.product];
          additionalOffer?.checkbox.forEach(offerCheckbox => {
            if (offerCheckbox.checked) productsToAdd.push(offerCheckbox.dataset.product);
          });

          // Add to cart
          if (miniCart && window.innerWidth > 768) {
            formData.sections = 'mt-mini-cart';

            const addToCart = () => {
              app.cart.updateView(formData, 'add', () => {
                if (form.getAttribute('data-force-cart')) {
                  window.top.location = _this.cartUrl;
                  return;
                }
                if (form.getAttribute('data-force-checkout')) {
                  window.top.location = '/checkout';
                  return;
                }
                miniCart.classList.add('active');
                miniCart.setAttribute('aria-hidden', false);
                setTimeout(() => miniCart.classList.add('visible'), 50);
                if (fields.button !== null) {
                  fields.button.disabled = false;
                  fields.button.classList.remove('mt-btn--loading');
                }
                app.dl.addedToCart(...productsToAdd);
              });
            };

            const executeAddToCart = () => {
              if (form.dataset.cartClear == 'true') {
                app.cart.clear(() => addToCart());
              } else {
                addToCart();
              }
            };
            
            if (app.discounts.hasMembership(formData.items)) {
              app.discounts.apply(app.discounts.membershipDiscountCode, executeAddToCart);
            } else {
              executeAddToCart();
            }
          } else {
            const addToCart = () => {
              fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
              })
                .then(response => response.json())
                .then(() => {
                  if (form.getAttribute('data-force-checkout')) {
                    window.top.location = '/checkout';
                    return;
                  }
                  if (fields.button !== null) {
                    fields.button.disabled = false;
                    fields.button.classList.remove('mt-btn--loading');
                  }
                  app.dl.addedToCart(...productsToAdd);
                  window.top.location = _this.cartUrl;
                })
                .catch((error) => {
                  console.error('Error:', error);
                  if (fields.button !== null) {
                    fields.button.disabled = false;
                    fields.button.classList.remove('mt-btn--loading');
                  }
                  window.top.location.reload();
                });
            };
            
            const executeAddToCart = () => {
              if (form.dataset.cartClear == 'true') {
                app.cart.clear(() => addToCart());
              } else {
                addToCart();
              }
            };

            // Apply discount if membership product detected
            if (app.discounts.hasMembership(formData.items)) {
              app.discounts.apply(app.discounts.membershipDiscountCode, executeAddToCart);
            } else {
              executeAddToCart();
            }
          }
        });

        fields.button && (fields.button.disabled = false);
        stickyProductForm && (stickyProductForm.disabled = false);

        form.dataset.events = true;
      });
    }
  },

  productItem: {
    els: document.querySelectorAll('.mt-product-item:not([data-events="true"])'),

    init: function() {
      const _this = this;
      _this.els = document.querySelectorAll('.mt-product-item:not([data-events="true"])');

      if (_this.els.length === 0) return;
      const collectionName = document.querySelector('.mt-collection-header')?.dataset.collection || '';
      _this.els.forEach(item => {
        const sectionName = item.closest('section').querySelector('.mt-featured-collection__heading, .mt-collection__heading, .featured-collection__heading');
        const itemTitle = item.querySelector('.mt-product-item__title');
        const itemLinks = item.querySelectorAll('.mt-product-item__image-wrapper, .mt-product-item__title');
        const itemDetails = item.querySelector('.mt-product-form input[name="id"]') || item.querySelector('.mt-product-form a[data-product]');
        const itemLinkCTA = item.querySelector('.mt-product-form a.mt-btn');
        const isCourse = item.dataset.course === 'true';

        itemLinks.forEach(link => {
          link.addEventListener('click', () => {
            if (isCourse) {
              window.app.dl.ctaClick(itemTitle.innerText, { location: (sectionName ? sectionName.innerText : ''), ...(collectionName && { collection_name: collectionName }) });
            } else if (itemDetails) {
              window.app.dl.selectItem(itemDetails.dataset.product, (sectionName ? sectionName.innerText : ''));
            }
          });
        });

        itemLinkCTA?.addEventListener('click', () => {
          window.app.dl.ctaClick(itemTitle.innerText, { location: (sectionName ? sectionName.innerText : ''), ...(collectionName && { collection_name: collectionName }) });
        });

        item.dataset.events = true;
      });
    }
  },

  cart: {
    el: {
      cartForm: document.querySelector('#mt-cart-form'),
      cartIcon: document.querySelector('.mt-header__cart'),
      cartPageContent: document.querySelector('.mt-cart-page__content'),
      cartPageHeader: document.querySelector('.mt-cart-page__header'),
      miniCart: document.querySelector('.mt-mini-cart'),
      miniCartClose: document.querySelector('.mt-mini-cart__close'),
      itemsList: document.querySelector('.mt-cart'),
      items: document.querySelectorAll('.mt-cart__item:not(.mt-cart-item--headers)'),
      summary: document.querySelector('.mt-cart-page__summary, .mt-mini-cart__summary'),
      summaryButton: document.querySelector('.mt-cart-page__summary-button, .mt-mini-cart__summary-button--checkout'),
      empty: document.querySelector('.mt-cart-page__empty, .mt-mini-cart__empty'),
      limitNotice: document.querySelector('.mt-cart-notice')
    },
    bundlesAs: 'separate',
    bundles: {},
    bundlesAdjust: (window.sessionStorage.getItem('mt-cart-adjustment') !== null) ? JSON.parse(window.sessionStorage.getItem('mt-cart-adjustment')) : {},
    notForSale: { variants: [], keysToRemove: [] },
    cartLimit: 20,
    cartType: null,

    debounce: function (func, timeout = 300) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
      };
    },

    clear: function (cb = null) {
      fetch(window.Shopify.routes.root + 'cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      })
        .then(r => r.json())
        .then(r => (r.item_count === 0 && typeof cb === 'function') && cb());
    },

    updateView: function (data = null, type = 'update', cb = null) {
      if (data === null) return;

      const _this = this;
      const cartUrl = {
        add: 'cart/add.js',
        update: 'cart/update.json'
      };
      _this.el.itemsList.classList.add('mt-cart--loading');
      _this.el.summaryButton && (_this.el.summaryButton.disabled = true);

      // Sync adjustment
      window.sessionStorage.setItem('mt-cart-adjustment', JSON.stringify(_this.bundlesAdjust));

      // Update section ID on cart page
      let sectionId = data.sections;
      if (sectionId === 'main-mt-cart') {
        sectionId = document.querySelector('.mt-cart-page').dataset.section;
        data.sections = sectionId;
      }

      fetch(window.Shopify.routes.root + cartUrl[type], {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(response => {
          const view = document.createElement('div');

          // Cart page
          if (_this.cartType === 'page') {
            view.innerHTML = response.sections[sectionId];

            const sections = {
              pageHeader: view.querySelector('.mt-cart-page__header'),
              itemsList: view.querySelector('.mt-cart'),
              items: view.querySelectorAll('.mt-cart__item'),
              summary: view.querySelector('.mt-cart-page__summary'),
              summarySufio: view.querySelector('.sufio-vat-cart-form'),
              empty: view.querySelector('.mt-cart-page__empty'),
              limitNotice: view.querySelector('.mt-cart-notice')
            };

            let contentHtml = '';
            (sections.limitNotice) && (contentHtml += sections.limitNotice.outerHTML);
            if (sections.empty) {
              contentHtml += sections.empty.outerHTML;
            } else {
              (sections.itemsList) && (contentHtml += sections.itemsList.outerHTML);
              (sections.summary) && (contentHtml += sections.summary.outerHTML);
            }
            _this.el.cartPageHeader.outerHTML = sections.pageHeader.outerHTML;
            _this.el.cartPageContent.innerHTML = contentHtml;

            _this.el.cartForm = document.querySelector('#mt-cart-form');
            _this.el.cartPageHeader = document.querySelector('.mt-cart-page__header');
            _this.el.itemsList = document.querySelector('.mt-cart-page .mt-cart');
            _this.el.items = document.querySelectorAll('.mt-cart-page .mt-cart__item:not(.mt-cart__item--headers)');
            _this.el.summary = document.querySelector('.mt-cart-page__summary');
            _this.el.summaryButton = document.querySelector('.mt-cart-page__summary-button');

            _this.el.itemsList && _this.el.itemsList.classList.remove('mt-cart--loading');
            _this.el.summaryButton && (_this.el.summaryButton.disabled = false);
            (sections.summarySufio && typeof SufioVAT !== 'undefined') && SufioVAT.onCart({ selectors: ".sufio-vat-cart-form" });

            _this.el.cartIcon && _this.el.cartIcon.setAttribute('data-items', sections.itemsList.dataset.items);

            if (typeof affirm === 'object') affirm?.ui?.refresh?.();
          }

          // Mini cart
          if (_this.cartType === 'mini') {
            view.innerHTML = response.sections['mt-mini-cart'];

            const sections = {
              miniCart: view.querySelector('.mt-mini-cart'),
              itemsList: view.querySelector('.mt-cart'),
              items: view.querySelectorAll('.mt-cart__item'),
              summary: view.querySelector('.mt-mini-cart__summary'),
              empty: view.querySelector('.mt-mini-cart__empty'),
              limitNotice: view.querySelector('.mt-cart-notice')
            };

            _this.el.itemsList.innerHTML = sections.itemsList.innerHTML;
            _this.el.summary.innerHTML = sections.summary.innerHTML;
            _this.el.empty.outerHTML = sections.empty.outerHTML;

            _this.el.miniCart.setAttribute('data-items', sections.miniCart.dataset.items);
            _this.el.miniCart.setAttribute('data-item-lines', sections.miniCart.dataset.itemLines);

            _this.el.itemsList = document.querySelector('.mt-cart');
            _this.el.items = document.querySelectorAll('.mt-cart__item');
            _this.el.summary = document.querySelector('.mt-mini-cart__summary');
            _this.el.summaryButton = document.querySelector('.mt-mini-cart__summary-button--checkout');
            _this.el.empty = document.querySelector('.mt-mini-cart__empty');

            _this.el.itemsList && _this.el.itemsList.classList.remove('mt-cart--loading');
            _this.el.summaryButton && (_this.el.summaryButton.disabled = false);

            _this.el.cartIcon && _this.el.cartIcon.setAttribute('data-items', sections.miniCart.dataset.items);
          }

          // Fire custom event
          const updateEvent = new CustomEvent('mt-cart-update', {});
          document.dispatchEvent(updateEvent);

          (cb !== null) && cb();
          _this.init();
        })
        .catch((error) => {
          console.error('Error:', error);
          window.top.location.reload();
        });
    },

    verifyBundles: function () {
      const _this = this;

      if (Object.keys(_this.bundles).length > 0) {
        const bundlesUpdate = { updates: {} };
        bundlesUpdate.sections = (_this.cartType === 'page') ? 'main-mt-cart' : 'mt-mini-cart';

        Object.keys(_this.bundles).forEach(key => {
          const bundle = _this.bundles[key];
          const bundleMemberships = bundle.products.filter(product => (product.type === 'membership'));
          let filteredProducts = [];

          // Remove broken bundles
          if (bundle.products.length === 1 && !_this.bundlesAdjust[bundle.products[0].id]) {
            bundlesUpdate.updates[bundle.products[0].key] = 0;
          }

          if (_this.bundlesAs === 'separate') {
            filteredProducts = bundle.products.filter(product => (product.quantity !== bundle.quantity && product.type !== 'membership'));

            // Separate memberships logic
            const filteredMemberships = bundle.products.filter(product => product.type === 'membership');
            let membershipsQuantity = 0;
            filteredMemberships.forEach(membership => (membershipsQuantity += membership.quantity));

            if (filteredMemberships.length > 0 && filteredMemberships.length !== bundle.quantity) {
              if (bundle.quantity > filteredMemberships.length) {
                const membership = filteredMemberships[0];
                const bundlesToAddData = { items: [] };
                bundlesToAddData.sections = (_this.cartType === 'page') ? 'main-mt-cart' : 'mt-mini-cart';
                let diff = bundle.quantity - filteredMemberships.length;
                (_this.bundlesAdjust[membership.id]) && (diff -= _this.bundlesAdjust[membership.id]);

                if (diff > 0) {
                  for (let i = 0; i < diff; i++) {
                    const bundleIdQ = Math.random().toString(36).slice(2, 7);
                    const sellingPlan = membership.sellingPlan ? Number(membership.sellingPlan) : null;
                    bundlesToAddData.items.push({
                      id: Number(membership.variantId),
                      quantity: 1,
                      selling_plan: sellingPlan,
                      properties: {
                        _bundleId: membership.id,
                        _bundleIdQ: `${membership.id}:${bundleIdQ}`,
                        _sellingPlan: sellingPlan,
                        _itemEditable: (membership.editable === "true"),
                        _itemRemovable: (membership.removable === "true")
                      }
                    });
                  }
                  _this.updateView(bundlesToAddData, 'add');
                }
              }
              if (bundle.quantity < filteredMemberships.length) {
                const diff = filteredMemberships.length - bundle.quantity;
                for (let i = 0; i < diff; i++) {
                  const membership = filteredMemberships.shift();
                  bundlesUpdate.updates[membership.key] = 0;

                  (_this.bundlesAdjust[membership.id]) && (_this.bundlesAdjust[membership.id] = 0);
                }
              }
            } else if (filteredMemberships.length > 0 && membershipsQuantity != bundle.quantity) {
              filteredMemberships.forEach(membership => (bundlesUpdate.updates[membership.key] = 1));
            }
          } else {
            if (bundleMemberships.length === 1) {
              filteredProducts = bundle.products.filter(product => (product.quantity !== bundle.quantity));
            } else {
              bundleMemberships.shift();
              bundleMemberships.forEach(membership => (bundlesUpdate.updates[membership.key] = 0));
            }
          }

          // Get products with different quantities 
          if (filteredProducts.length > 0) {
            filteredProducts.forEach(product => (bundlesUpdate.updates[product.key] = bundle.quantity));
          }
        });

        // Update view if required
        if (Object.keys(bundlesUpdate.updates).length > 0) {
          _this.updateView(bundlesUpdate, 'update');
        }
      }
    },

    getAllBundles: function () {
      const _this = this;

      _this.bundles = [];

      _this.el.items.forEach(item => {
        const itemData = {
          bundleId: item.dataset.bundleId,
          bundleIdQ: item.dataset.bundleIdq,
          key: item.dataset.key,
          type: item.dataset.type,
          variantId: item.dataset.variant,
          productId: item.dataset.product,
          sellingPlan: item.dataset.sellingPlan,
          quantity: Number(item.dataset.quantity),
          editable: item.dataset.editable,
          removable: item.dataset.removable
        };
        const itemConnection = (window.app.cartConnections && window.app.cartConnections.length > 0) ? window.app.cartConnections.filter(connection => connection.products_id_list.includes(Number(itemData.productId))) : [];

        if (itemData.bundleId) {
          if (_this.bundles[itemData.bundleId]) {
            (itemData.type === 'product-main' && !_this.bundles[itemData.bundleId].quantity) && (_this.bundles[itemData.bundleId].quantity = itemData.quantity);
            _this.bundles[itemData.bundleId].products.push({
              key: itemData.key,
              variantId: itemData.variantId,
              productId: itemData.productId,
              sellingPlan: itemData.sellingPlan ? itemData.sellingPlan : null,
              id: itemData.bundleId,
              idQ: itemData.bundleIdQ ? itemData.bundleIdQ : null,
              quantity: itemData.quantity,
              type: itemData.type,
              editable: itemData.editable,
              removable: itemData.removable
            });
          } else {
            _this.bundles[itemData.bundleId] = {
              quantity: (itemData.type === 'product-main') ? itemData.quantity : 0,
              products: [
                {
                  key: itemData.key,
                  variantId: itemData.variantId,
                  productId: itemData.productId,
                  sellingPlan: itemData.sellingPlan ? itemData.sellingPlan : null,
                  id: itemData.bundleId,
                  idQ: itemData.bundleIdQ ? itemData.bundleIdQ : null,
                  quantity: itemData.quantity,
                  type: itemData.type,
                  editable: itemData.editable,
                  removable: itemData.removable
                }
              ]
            };
          }
        } else if (itemConnection.length > 0) {
          // Remove the damaged bundles
          const tempBundleId = Math.random().toString(36).slice(2, 7);
          _this.bundles[tempBundleId] = {
            quantity: (itemData.type === 'product-main') ? itemData.quantity : 0,
            products: [
              {
                key: itemData.key,
                variantId: itemData.variantId,
                productId: itemData.productId,
                sellingPlan: null,
                id: tempBundleId,
                idQ: null,
                quantity: itemData.quantity,
                type: 'product',
                editable: false,
                removable: false
              }
            ]
          };
        }
      });

      (Object.keys(_this.bundles).length > 0) && _this.verifyBundles();
    },

    init: function () {
      const _this = this;
      const processChange = _this.debounce((data, cb = null) => _this.updateView(data, 'update', cb));

      if (_this.el.items === 0) return;

      _this.cartType = _this.el.cartPageContent ? 'page' : 'mini';
      _this.notForSale.variants = [..._this.el.items].filter(i => i.dataset.nfs).map(i => Number(i.dataset.variant));
      _this.notForSale.keysToRemove = [];
      _this.el.items.forEach(item => {
        const itemKey = item.dataset.key;
        const itemVariant = item.dataset.variant;
        const itemBundleId = item.dataset.bundleId;
        const quantityInput = item.querySelector('.mt-quantity__input');
        const removeButton = item.querySelector('.mt-cart-item__remove a');

        // Not for individual sale
        if (_this.notForSale.variants.includes(Number(itemVariant))) {
          if (!itemBundleId) {
            _this.notForSale.keysToRemove.push(itemKey);
          } else {
            const otherItems = [..._this.el.items].filter(item => item.dataset.bundleId === itemBundleId);
            (otherItems.length === 1) && _this.notForSale.keysToRemove.push(itemKey);
          }
        }

        // Quantity
        if (quantityInput && !quantityInput.getAttribute('data-event')) {
          quantityInput.addEventListener('change', e => {
            e.preventDefault();
            const data = { updates: {} };
            const quantity = (Number(quantityInput.value) > _this.cartLimit) ? _this.cartLimit : Number(quantityInput.value);
            data.sections = (_this.cartType === 'page') ? 'main-mt-cart' : 'mt-mini-cart';
            data.updates[itemKey] = quantity;

            // ATC event
            let cb = null;
            if (quantity > quantityInput.getAttribute('value')) {
              const product = JSON.parse(item.dataset.productJson);
              product.quantity = quantity - Number(quantityInput.getAttribute('value'));
              cb = () => app.dl.addedToCart(JSON.stringify(product));
            }

            processChange(data, cb);
          });
          quantityInput.setAttribute('data-event', 1);
        }

        // Remove
        if (removeButton) {
          removeButton.addEventListener('click', e => {
            e.preventDefault();
            const data = { updates: {} };
            data.sections = (_this.cartType === 'page') ? 'main-mt-cart' : 'mt-mini-cart';
            data.updates[itemKey] = 0;

            if (itemBundleId !== '') {
              if (_this.bundlesAdjust[itemBundleId]) {
                _this.bundlesAdjust[itemBundleId] += 1;
              } else {
                _this.bundlesAdjust[itemBundleId] = 1;
              }
              
              const otherItems = [...document.querySelectorAll(`.mt-cart-item[data-bundle-id="${itemBundleId}"]`)].filter(i => i.dataset.key !== itemKey);
              if (otherItems.every(item => item.dataset.editable === 'false' && item.dataset.removable === 'false')) {
                otherItems.forEach(item => (data.updates[item.dataset.key] = 0));
              }
            }

            _this.updateView(data, 'update');
          });
        }
      });

      // Not for individual sale
      if (_this.notForSale.keysToRemove.length > 0) {
        const data = { updates: {} };
        data.sections = (_this.cartType === 'page') ? 'main-mt-cart' : 'mt-mini-cart';
        _this.notForSale.keysToRemove.forEach(key => (data.updates[key] = 0));
        _this.updateView(data, 'update');
      }

      // Mini cart
      if (_this.el.miniCart) {
        _this.el.miniCartClose.addEventListener('click', e => {
          e.preventDefault();
          _this.el.miniCart.classList.remove('visible');
          _this.el.miniCart.setAttribute('aria-hidden', true);
          setTimeout(() => _this.el.miniCart.classList.remove('active'), 300);
        });
      }

      // Sticky form on cart page
      if (_this.el.summary && _this.el.cartPageContent) {
        const stickySummary = () => {
          const parentRect = _this.el.cartPageContent.getBoundingClientRect();
          const elementRect = _this.el.summary.getBoundingClientRect();

          if (Math.round(elementRect.bottom) >= Math.round(parentRect.bottom)) {
            _this.el.summary.classList.remove('mt-cart-page__summary--sticky');
          } else {
            _this.el.summary.classList.add('mt-cart-page__summary--sticky');
          }
        };
        stickySummary();
        window.addEventListener('scroll', () => stickySummary());
      }

      // Disable submit by Enter
      if (_this.el.cartForm) {
        _this.el.cartForm.addEventListener('keydown', e => {
          if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
          }
        });
      }

      _this.getAllBundles();
    }
  },

  collection: {
    el: {
      section: document.querySelectorAll('.mt-collection'),
      filters: document.querySelectorAll('.mt-collection-filters__list--dynamic'),
      toggleButton: document.querySelectorAll('.mt-collection__view-all'),
      cpOtherSections: document.querySelectorAll('.mt-slim-banner, .mt-membership-offers')
    },
    filterHashes: ['#all'],
    isCollectionPage: (document.querySelector('.template-collection')) ? true : false,

    filters: function () {
      const _this = this;
      if (_this.el.filters.length === 0) return;

      const allCollections = document.querySelectorAll('.mt-collection');
      _this.el.filters.forEach(filterBox => {
        const filters = filterBox.querySelectorAll('a');

        filters.forEach(filter => {
          const collection = document.querySelector(`${filter.hash}.mt-collection`);
          const collectionToggle = collection?.querySelectorAll('.mt-collection__view-all, .mt-collection__action-wrapper');
          const collectionHiddenProducts = collection?.querySelectorAll('.mt-collection__list-item--hidden-default');
          const filterItem = filter.closest('li');

          if (collection || _this.filterHashes.includes(filter.hash)) {
            _this.filterHashes.push(filter.hash);
            filter.addEventListener('click', e => {
              e.preventDefault();

              if (filter.hash === '#all') {
                allCollections.forEach(c => {
                  (c.id === 'sale') ? c.classList.add('hidden') : c.classList.remove('hidden');
                  const cToggle = c.querySelectorAll('.mt-collection__view-all, .mt-collection__action-wrapper');
                  const cHiddenProducts = c.querySelectorAll('.mt-collection__list-item--hidden-default');
                  if (cToggle.length > 0) {
                    cToggle.forEach(ct => ct.classList.remove('hidden'));
                    cHiddenProducts.forEach(product => product.classList.add('hidden'));
                  }
                });
                _this.isCollectionPage && _this.el.cpOtherSections.forEach(section => section.classList.remove('hidden'));
              } else {
                allCollections.forEach(c => c.classList.add('hidden'));
                collection.classList.remove('hidden');

                if (collectionToggle.length > 0) {
                  collectionToggle.forEach(ct => ct.classList.add('hidden'));
                  collectionHiddenProducts.forEach(product => product.classList.remove('hidden'));
                }
                if (_this.isCollectionPage) {
                  _this.el.cpOtherSections.forEach(section => section.classList.add('hidden'));
                }
              }
              filters.forEach(f => f.classList.remove('active'));
              filter.classList.add('active');
              filterItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

              // Update URL
              let currentUrl = window.top.location.href.split('#')[0];
              (filter.hash !== '#all') && (currentUrl += filter.hash);
              window.history.replaceState(null, document.title, currentUrl);
            });
          } else {
            filterItem.remove();
          }
        });
      });

      if (window.location.hash && _this.el.filters.length > 0) {
        const filterHash = window.location.hash.split('?')[0];
        if (_this.filterHashes.includes(filterHash)) {
          const filter = _this.el.filters[0].querySelector(`a[href="${filterHash}"]`);
          filter.dispatchEvent(new Event('click'));
        }
      }
    },

    init: function () {
      const _this = this;
      if (_this.el.section.length === 0) return;

      // Additional events
      _this.el.toggleButton.forEach(button => {
        const t = { all: button.dataset.tAll, less: button.dataset.tLess };
        const collection = button.closest('.mt-collection');
        const allToggleButtons = collection.querySelectorAll('.mt-collection__view-all');
        const allProducts = collection.querySelectorAll('.mt-collection__list-item');
      
        button.addEventListener('click', e => {
          e.preventDefault();
          button.classList.toggle('active');
          const isActive = button.classList.contains('active');
          allProducts.forEach(product => {
            const shouldBeHidden = !isActive && product.classList.contains('mt-collection__list-item--hidden-default');
            product.classList.toggle('hidden', shouldBeHidden);
          });
          allToggleButtons.forEach(b => { b.querySelector('span:first-child').innerHTML = isActive ? t.less : t.all; });
        });
      });      

      // Filters
      _this.filters();
    }
  },

  header: {
    el: {
      body: document.querySelector('body'),
      headerWrapper: document.querySelector('.mt-header-wrapper'),
      header: document.querySelector('.mt-header'),
      nav: document.querySelector('.mt-header__nav'),
      navItems: document.querySelectorAll('.mt-header__nav-item'),
      navLinks: document.querySelectorAll('.mt-header__nav-link, .mt-header-mobile__link, .mt-mega-menu__subnav-link, .mt-mega-menu__subnav-item__banner, .mt-mega-menu__card-link'),
      mobileNavItems: document.querySelectorAll('.mt-header-mobile__item--dropdown'),
      megaMenus: document.querySelectorAll('.mt-mega-menu'),
      announcementBar: document.querySelector('.mt-announcement-bar-section'),
      mobileToggler: document.querySelector('.mt-header__mobile-toggle'),
      dropdownLinks: document.querySelectorAll('.mt-header-mobile__item-drop')
    },
    stickyOffset: 0,

    calculateHeight: function () {
      const _this = this;
      let stickyOffset = 0;

      if (_this.el.announcementBar) {
        document.documentElement.style.setProperty('--announcement-bar-height', `${_this.el.announcementBar.clientHeight}px`);
        stickyOffset += _this.el.announcementBar.clientHeight;
      }

      _this.stickyOffset = stickyOffset;
    },
    
    debounce: function (func, timeout = 300) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          func.apply(this, args);
        }, timeout);
      };
    },

    init: function () {
      const _this = this;
      window.addEventListener('DOMContentLoaded', () => _this.calculateHeight());
      window.addEventListener('resize', _this.debounce(() => { _this.calculateHeight(); }, 100));
      window.addEventListener('load', () => _this.calculateHeight());

      // Sticky header
      const stickyHeader = () => {
        if (!_this.el.header) return;

        if (window.scrollY > _this.stickyOffset) {
          _this.el.header.classList.add('mt-header--sticky');
          _this.el.headerWrapper?.classList.add('sticky');
        } else {
          _this.el.header.classList.remove('mt-header--sticky');
          _this.el.headerWrapper?.classList.remove('sticky');
        };
      };
      stickyHeader();
      window.addEventListener('scroll', () => stickyHeader());

      // Mega menu
      const MM_TOGGLE_DELAY = 300;
      let hideMenuTimeout;
      let currentOpenMenu = null;

      // Helper function to manage focusable items in mega menus
      const setMegaMenuItemsFocusable = (megaMenu, focusable) => {
        const links = megaMenu.querySelectorAll('.mt-mega-menu__subnav-link, .mt-mm-banner, .mt-mm-product');
        const tabindex = focusable ? '0' : '-1';
        links.forEach(link => {
          link.setAttribute('tabindex', tabindex);
        });
      };

      const closeAllMenus = () => {
        _this.el.nav.classList.remove('is-highlighted');
        _this.el.navItems.forEach(i => {
          i.classList.remove('is-active');
          const navLink = i.querySelector('.mt-header__nav-link');
          if (navLink?.hasAttribute('aria-expanded')) {
            navLink.setAttribute('aria-expanded', 'false');
          }
        });
        _this.el.header.querySelectorAll('.mt-mega-menu').forEach(mm => {
          mm.classList.add('hidden');
          mm.setAttribute('aria-hidden', true);
          setMegaMenuItemsFocusable(mm, false);
        });
        currentOpenMenu = null;
      };

      _this.el.navItems.forEach(item => {
        const link = item.querySelector('.mt-header__nav-link');
        const megaMenu = item.querySelector('.mt-mega-menu');
        const megaMenuInner = megaMenu?.querySelector('.mt-mega-menu__inner');
        const hasMegaMenu = item.classList.contains('mt-header__nav-item--dropdown');

        const showMenu = () => {
          // Highlight the current item
          _this.el.nav.classList.add('is-highlighted');
          _this.el.navItems.forEach(i => i.classList.remove('is-active'));
          item.classList.add('is-active');
          if (hasMegaMenu) {
            link.setAttribute('aria-expanded', 'true');
          }

          if (megaMenu) {
            const mmSublinks = megaMenu.querySelectorAll('.mt-mega-menu__subnav-item');
            const mmImageAssets = Array.from(mmSublinks).flatMap(sublink => {
              const sublinkData = sublink.dataset.related ? JSON.parse(sublink.dataset.related) : null;
              if (sublinkData) {
                return [
                  sublinkData.bannerImage || null, 
                  sublinkData.productImage || null
                ].filter(image => image !== null);
              }
              return [];
            });
            app.utilities.preloadImages(...new Set(mmImageAssets));
            megaMenu.classList.remove('hidden');
            megaMenu.setAttribute('aria-hidden', false);
            currentOpenMenu = megaMenu;
            setMegaMenuItemsFocusable(megaMenu, true);
          }
            
          // Close other mega menus
          _this.el.header.querySelectorAll('.mt-mega-menu:not(.hidden)').forEach(mm => {
            if (mm !== megaMenu) {
              mm.classList.add('hidden');
              mm.setAttribute('aria-hidden', true);
              setMegaMenuItemsFocusable(mm, false);
            }
          });
        };

        const hideMenu = () => {
          _this.el.nav.classList.remove('is-highlighted');
          _this.el.navItems.forEach(i => i.classList.remove('is-active'));
          if (hasMegaMenu) {
            link.setAttribute('aria-expanded', 'false');
          }

          if (megaMenu) {
            megaMenu.classList.add('hidden');
            megaMenu.setAttribute('aria-hidden', true);
            currentOpenMenu = null;
            setMegaMenuItemsFocusable(megaMenu, false);
          }
        };

        // Mouse events
        link.addEventListener('mouseenter', () => {
          clearTimeout(hideMenuTimeout);
          showMenu();
        });
        link.addEventListener('mouseleave', () => {
          hideMenuTimeout = setTimeout(hideMenu, MM_TOGGLE_DELAY);
        });

        // Keyboard events
        if (hasMegaMenu) {
          link.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              if (megaMenu.classList.contains('hidden')) {
                showMenu();
                const firstLink = megaMenu.querySelector('.mt-mega-menu__subnav-link');
                if (firstLink) {
                  setTimeout(() => firstLink.focus(), 100);
                }
              } else {
                hideMenu();
              }
            }
            if (e.key === 'ArrowDown') {
              e.preventDefault();
              showMenu();
              const firstLink = megaMenu.querySelector('.mt-mega-menu__subnav-link');
              if (firstLink) {
                setTimeout(() => firstLink.focus(), 100);
              }
            }
            if (e.key === 'Escape') {
              e.preventDefault();
              hideMenu();
              link.focus();
            }
          });
        }

        if (megaMenu) {
          megaMenuInner?.addEventListener('mouseenter', () => {
            clearTimeout(hideMenuTimeout);
          });
          megaMenuInner?.addEventListener('mouseleave', () => {
            hideMenuTimeout = setTimeout(hideMenu, MM_TOGGLE_DELAY);
          });

          // Keyboard navigation within mega menu
          const megaMenuLinks = megaMenu.querySelectorAll('.mt-mega-menu__subnav-link, .mt-mm-banner, .mt-mm-product');
          megaMenuLinks.forEach((menuLink, index) => {
            menuLink.addEventListener('keydown', (e) => {
              if (e.key === 'Escape') {
                e.preventDefault();
                hideMenu();
                link.focus();
              }
              if (e.key === 'ArrowDown') {
                e.preventDefault();
                const nextLink = megaMenuLinks[index + 1] || megaMenuLinks[0];
                nextLink.focus();
              }
              if (e.key === 'ArrowUp') {
                e.preventDefault();
                const prevLink = megaMenuLinks[index - 1] || megaMenuLinks[megaMenuLinks.length - 1];
                prevLink.focus();
              }
              // Close menu when tabbing out from last item
              if (e.key === 'Tab' && !e.shiftKey && index === megaMenuLinks.length - 1) {
                setTimeout(() => {
                  const focusedElement = document.activeElement;
                  const headerSection = document.querySelector('.mt-header-wrapper') || _this.el.header;
                  if (!headerSection.contains(focusedElement)) {
                    closeAllMenus();
                  }
                }, 0);
              }
            });
          });
        }
      });

      // Close mega menu on Escape (global)
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && currentOpenMenu) {
          closeAllMenus();
        }
      });

      // Close mega menu when focus leaves header (Tab navigation)
      document.addEventListener('focusin', (e) => {
        if (currentOpenMenu) {
          const focusedElement = e.target;
          const headerSection = document.querySelector('.mt-header-wrapper') || _this.el.header;
          const isInsideHeader = headerSection && (
            headerSection.contains(focusedElement) || 
            currentOpenMenu.contains(focusedElement)
          );
          
          if (!isInsideHeader) {
            closeAllMenus();
          }
        }
      });

      _this.el.mobileNavItems.forEach(item => {
        const link = item.querySelector('.mt-header-mobile__link');
        const toggleButton = item.querySelector('.mt-header-mobile__toggle-btn');
        const megaMenu = item.querySelector('.mt-mega-menu');
        const toggleMegaMenu = () => {
          _this.el.header.querySelectorAll('.mt-mega-menu:not(.hidden)').forEach(mm => {
            if (mm !== megaMenu) {
              const relItem = mm.closest('.mt-header-mobile__item--dropdown');
              mm.classList.add('hidden');
              mm.setAttribute('aria-hidden', true);
              relItem?.classList.remove('is-active');
            }
          });
          megaMenu.classList.toggle('hidden');
          megaMenu.setAttribute('aria-hidden', megaMenu.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
          item.classList.toggle('is-active');
        }

        link.addEventListener('click', e => {
          if (link.getAttribute('href') === '#' || link?.href?.includes('#')) {
            e.preventDefault();
            if (megaMenu) toggleMegaMenu();
          }
        });

        toggleButton.addEventListener('click', e => {
          e.preventDefault();
          megaMenu && toggleMegaMenu();
        });
      });

      _this.el.megaMenus.forEach(menu => {
        const links = menu.querySelectorAll('.mt-mega-menu__subnav-link');
        const elements = {
          extra: document.querySelector('.mt-mega-menu__extra'),
          banner: {
            el: menu.querySelector('.mt-mm-banner'),
            imageWrapper: menu.querySelector('.mt-mm-banner__image-wrapper'),
            image: menu.querySelector('.mt-mm-banner__image-wrapper > img'),
            video: menu.querySelector('.mt-mm-banner__image-wrapper > video'),
            title: menu.querySelector('.mt-mm-banner__title'),
            button: menu.querySelector('.mt-mm-banner__btn')
          },
          product: {
            el: menu.querySelector('.mt-mm-product'), 
            imageWrapper: menu.querySelector('.mt-mm-product__image-wrapper'),
            image: menu.querySelector('.mt-mm-product__image-wrapper > img'),
            title: menu.querySelector('.mt-mm-product__title'),
            titleText: menu.querySelector('.mt-mm-product__title > span:first-child')
          }
        };
        
        links.forEach(link => {
          const item = link.closest('.mt-mega-menu__subnav-item');
        
          link.addEventListener('mouseenter', () => {
            const itemData = JSON.parse(item.dataset.related);
            const updateElement = (element, data, fields) => {
              element.el.classList.toggle('hidden', !data[fields.image]);
              if (data[fields.image]) {
                element.image.src = data[fields.image];
                element.title.href = data[fields.link] || link.href;
                element.title.dataset.linkText = data[fields.titleText] || link.dataset.linkText || link.innerText;
                element.imageWrapper.href = data[fields.link] || link.href;
                element.imageWrapper.title = data[fields.titleText] || link.dataset.linkText || link.innerText;
                if (element.titleText) {
                  element.titleText.innerText = data[fields.titleText] || link.dataset.linkText || link.innerText;
                } else {
                  element.title.innerText = data[fields.titleText] || link.dataset.linkText || link.innerText;
                }
                if (element.button && fields.button) {
                  element.button.innerText = data[fields.button] || link.dataset.linkText || link.innerText;
                  element.button.classList.toggle('hidden', !data.bannerButton);
                }
              }
            };
        
            // Update banner
            updateElement(elements.banner, itemData, {
              image: 'bannerImage',
              titleText: 'bannerTitle',
              link: 'bannerUrl',
              button: 'bannerTitle'
            });
        
            // Update product
            updateElement(elements.product, itemData, {
              image: 'productImage',
              titleText: 'productTitle',
              link: 'productUrl'
            });

            // Update classes
            elements.banner.el.classList.toggle('is-large', !itemData.productImage);
            elements.product.el.classList.toggle('is-large', !itemData.bannerImage);
          });
        });

        // Additional DL events 
        [elements.banner.imageWrapper, elements.banner.title, elements.product.imageWrapper, elements.product.title].forEach(el => {
          if (!el) return;
          el.addEventListener('click', () => {
            const linkText = el.dataset.linkText || el.title || el.innerText;
            const params = { 
              link_classes: (el.innerText) ? 'text' : 'image',
              link_id: el.dataset.parentGroup
            };

            window.app.dl.menuClick(linkText, params);
          });
        })
      });

      // Mobile drawer
      if (_this.el.mobileToggler) {
        _this.el.mobileToggler.addEventListener('click', e => {
          e.preventDefault();
          if (_this.el.body.hasAttribute('data-header-mobile-active')) {
            _this.el.body.removeAttribute('data-header-mobile-active');
          } else {
            _this.el.body.setAttribute('data-header-mobile-active', true);
            window.app.dl.menuOpen();
          }
        });
      }

      const mobileHeaderDrawer = () => (window.innerWidth >= 1000 && _this.el.body.hasAttribute('data-header-mobile-active')) && _this.el.body.removeAttribute('data-header-mobile-active');
      mobileHeaderDrawer();
      window.addEventListener('resize', () => mobileHeaderDrawer());

      // Nav links
      _this.el.navLinks.forEach(link => {
        link.addEventListener('click', e => {
          const params = { link_classes: link.classList.contains('mt-mega-menu__subnav-item__banner') ? 'image' : 'text' };
          const linkText = link.dataset.linkText || link.title || link.innerText;
          if (link.closest('.mt-header-mobile__item--dropdown, .mt-header__nav-item--dropdown') && link.dataset.parentGroup) {
            params.link_id = link.dataset.parentGroup;
          }

          (link?.href.endsWith('#')) && (e.preventDefault(), e.stopPropagation());
          (window.innerWidth >= 1000 || (window.innerWidth < 1000 && link.getAttribute('href') !== '#') && !link?.href?.includes('#')) && window.app.dl.menuClick(linkText, params);
          (window.innerWidth < 1000 && (link.getAttribute('href') === '#' || link?.href?.includes('#'))) && window.app.dl.menuHover(linkText);
          app.vwo.event('navItemInteraction', {
            "linkText": linkText,
            "linkGroup": link.closest('.mt-header-mobile__item--dropdown, .mt-header__nav-item--dropdown') ? link.dataset.parentGroup || linkText : '',
            "type": "click"
          });
        });
        link.addEventListener('mouseenter', () => {
          const linkText = link.dataset.linkText || link.title || link.innerText;
          const linkGroup = link.closest('.mt-header-mobile__item--dropdown, .mt-header__nav-item--dropdown') ? link.dataset.parentGroup || linkText : linkText;

          (window.innerWidth >= 1000 && linkText === linkGroup) && window.app.dl.menuHover(linkText);
          app.vwo.event('navItemInteraction', {
            "linkText": linkText,
            "linkGroup": linkGroup,
            "type": "hover"
          });
        });
      });
    }
  },

  footer: {
    breakpoint: (window.innerWidth >= 992) ? 'desktop' : 'mobile',
    el: {
      menuHeaders: document.querySelectorAll('.mt-footer-nav__title'),
      accessibility: document.querySelectorAll('a[href*="#accessibility"]'),
      menus: document.querySelectorAll('.mt-footer-v2__menu')
    },

    initV2: function() {
      const _this = this;
      const toggleAllMenus = (action = 'show') => {
        _this.el.menus.forEach(menu => {
          const list = menu.querySelector('.mt-footer-v2__menu-list');

          if (action === 'show') {
            menu.open = true;
            menu.classList.add('is-active');
            list.setAttribute('aria-hidden', false);
          } else {
            menu.open = false;
            menu.classList.remove('is-active');
            list.setAttribute('aria-hidden', true);
          }
        });
      };

      _this.el.menus.forEach(menu => {
        const list = menu.querySelector('.mt-footer-v2__menu-list');
        
        menu.addEventListener('toggle', e => {
          e.preventDefault();
          if (_this.breakpoint === 'desktop') return;

          menu.classList.toggle('is-active', menu.open);
          list.setAttribute('aria-hidden', !menu.open);

          // Close other
          menu.open && _this.el.menus.forEach(m => {
            if (m === menu) return;

            m.open = false;
            m.classList.remove('is-active');
            m.querySelector('.mt-footer-v2__menu-list').setAttribute('aria-hidden', true);
          });
        });

        // Hide by default on mobile
        (window.innerWidth < 992) && toggleAllMenus('hide');
      });

      window.addEventListener('resize', () => {
        const newBreakpoint = (window.innerWidth >= 992) ? 'desktop' : 'mobile';
        if (newBreakpoint === _this.breakpoint) return;

        (newBreakpoint === 'desktop') ? toggleAllMenus('show') : toggleAllMenus('hide');
        _this.breakpoint = newBreakpoint;
      });
    },

    init: function () {
      const _this = this;
      if (_this.el.menuHeaders.length === 0 && _this.el.accessibility.length === 0) return;
      _this.el.menuHeaders.forEach(header => {
        const menu = header.closest('.mt-footer-nav');
        const list = menu.querySelector('.mt-footer-nav__list');
        header.addEventListener('click', e => {
          e.preventDefault();

          _this.el.menuHeaders.forEach(otherHeader => {
            if (header !== otherHeader) {
              const otherMenu = otherHeader.closest('.mt-footer-nav');
              const otherList = otherMenu.querySelector('.mt-footer-nav__list');
              otherMenu.classList.remove('active');
              otherList.setAttribute('aria-hidden', true);
            }
          });
          menu.classList.toggle('active');
          list.setAttribute('aria-hidden', !menu.classList.contains('active'));
        });
      });
      _this.el.accessibility.forEach(link => {
        link.addEventListener('click', e => e.preventDefault());
      });
      window.addEventListener('resize', () => {
        if (window.innerWidth < 768) return;

        const footerNavLists = document.querySelectorAll('.mt-footer-nav__list');
        footerNavLists.forEach(list => {
          list.setAttribute('aria-hidden', false);
        });
      });
    }
  },

  discounts: {
    membershipIds: [40703995805741, 40704022741037, 40387475243052, 40387475308588],
    membershipDiscountCode: 'DS-MEMB20AS90T',
    membershipDiscountEnabled: false,

    init: function () {
      const urlParams = new URLSearchParams(window.location.search);
      const discount = urlParams.get('discount');
      (discount !== null) && this.apply(discount);
    },

    hasMembership: function (items) {
      if (!this.membershipDiscountEnabled) return false;
      if (!items || !Array.isArray(items)) return false;
      return items.some(item => this.membershipIds.includes(Number(item.id)));
    },

    apply: function (code, callback = null) {
      if (!code) {
        (typeof callback === 'function') && callback();
        return;
      }
      fetch(`/discount/${code}`)
        .then(() => (typeof callback === 'function') && callback())
        .catch(() => (typeof callback === 'function') && callback());
    }
  },

  utilities: {
    setCookie: (name, value, days) => {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    },
    
    getCookie: name => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    },

    removeCookie: name => {
      document.cookie = name + '=; Max-Age=-99999999;';
    },

    preloadImages: (...args) => {
      const images = [];
      for (var i = 0; i < args.length; i++) {
        images[i] = new Image();
        images[i].src = args[i];
      }
    },

    validateMarketCatalog: async () => {
      const isEUHost = window.location.host === 'blazepod.eu';
      const urlParams = new URLSearchParams(window.location.search);
      const isAffiliate = urlParams.get('utm_medium') === 'affiliate';
      const ukPath = '/en-uk';
      if (!isEUHost || !isAffiliate) return;

      const redirectToUK = () => {
        const { pathname, search, origin } = window.location;
        window.location.href = `${origin}${ukPath}${pathname}${search}`;
      };

      let userCountry = window.sessionStorage.getItem('bpUserCountry') || '';

      if (!userCountry) {
        try {
          const response = await fetch(`${window.Shopify.routes.root}browsing_context_suggestions.json`);
          const data = await response.json();
          userCountry = data?.detected_values?.country?.handle || '';
          window.sessionStorage.setItem('bpUserCountry', userCountry);
        } catch (error) {
          console.error('Error fetching user country:', error);
          return;
        }
      }

      if (userCountry === 'GB' && !window.location.pathname.includes(ukPath)) {
        redirectToUK();
      }
    }
  },

  video: {
    els: document.querySelectorAll('.mt-video'),

    init: function () {
      const _this = this;
      if (_this.els.length === 0) return;

      _this.els.forEach(videoBlock => {
        const overlay = videoBlock.querySelector('.mt-video__overlay');
        const video = videoBlock.querySelector('video');

        overlay && overlay.addEventListener('click', e => {
          e.preventDefault();
          video && video.play();
        });

        video.addEventListener('play', () => {
          videoBlock.classList.add('mt-video--playing');
          video.controls = true;
        });

        video.addEventListener('pause', () => {
          videoBlock.classList.remove('mt-video--playing');
          video.controls = false;
        });

        videoBlock.classList.remove('mt-video--loading');
      });
    }
  },

  newsletter: {
    el: {
      footerForm: document.querySelector('.mt-footer-newsletter'),
      footerHeader: document.querySelector('.mt-footer-newsletter__header'),
      footerDescription: document.querySelector('.mt-footer-newsletter__description'),
      footerFields: document.querySelector('.mt-footer-newsletter__fields'),
      footerInput: document.querySelector('.mt-footer-newsletter input[name="contact[email]"]'),
      footerBtn: document.querySelector('.mt-footer-newsletter .mt-btn'),
      footerSuccess: document.querySelector('.mt-footer-newsletter__message--success'),
      footerError: document.querySelector('.mt-footer-newsletter__message--error')
    },

    showError: function (message = '') {
      const _this = this;

      _this.el.footerFields.classList.add('is-error');
      _this.el.footerError.innerHTML = (message !== '') ? message : _this.el.footerError.dataset.default;
      _this.el.footerError.classList.remove('hidden');
      _this.el.footerSuccess.classList.add('hidden');
    },

    showSuccess: function (email = '') {
      const _this = this;
     
      _this.el.footerHeader.innerHTML = _this.el.footerSuccess.dataset.header;
      _this.el.footerSuccess.innerHTML = _this.el.footerSuccess.innerHTML.replace('{email}', `<span>${email}</span>`);
      _this.el.footerForm.classList.add('mt-footer-newsletter--success');
    },
    
    validateEmail: function (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },

    init: function () {
      const _this = this;

      // Footer
      if (_this.el.footerForm && _this.el.footerBtn) {
        _this.el.footerForm.addEventListener('keydown', e => {
          if (e.key === "Enter") {
            e.preventDefault();
            e.stopPropagation();
            _this.el.footerBtn.dispatchEvent(new Event('click'));
          }
        });
        _this.el.footerBtn.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();

          const form = _this.el.footerForm;
          const email = form.querySelector('input[name="contact[email]"]');
          if (!email || email.value === '' || !_this.validateEmail(email.value)) {
            _this.showError('Enter a valid email address');
            return;
          }
          
          fetch(form.action, {
            method: form.method,
            body: new FormData(form)
          })
            .then(response => {
              if (response.url.includes('customer_posted=true')) {
                _this.showSuccess(email.value);
                app.dl.emailSignUp(email.value, 'footer');
              } else {
                _this.showError();
              }
            })
            .catch(() => {
              _this.showError();
            });
        });
      }

      // Klaviyo forms
      window.addEventListener('klaviyoForms', function(e) {
        if (e.detail.type == 'submit') {
          app.dl.emailSignUp(e.detail.metaData.$email, 'popup');
        }
      });
    }
  },

  textImage: {
    els: document.querySelectorAll('.mt-text-image'),

    init: function() {
      const _this = this;
      if (_this.els.length === 0) return;

      _this.els.forEach(el => {
        // General
        let header = el.querySelector('.mt-text-image__header');
        if (!header && el.classList.contains('mt-text-image--lets-talk')) {
          header = el.querySelector('.mt-text-image__description');
        }
        
        // Videos
        const video = el.querySelector('.mt-text-image__video');
        const videoButton = el.querySelector('.mt-text-image__video-btn');
        if (video && videoButton) {
          videoButton.addEventListener('click', e => {
            e.preventDefault();
            video.muted = !video.muted;
            video.controls = !video.controls;
            video.play();
            videoButton.classList.add('hidden');

            // Additional DL events
            if (el.id === 'reactive-intelligence') {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'video_play',
                video_name: window.app.dl.sanitize(header?.innerText)
              });
            }
          });
        }

        // Additional DL events
        const link = el.querySelector('.mt-text-image__action .mt-btn');
        if (link && header) {
          link.addEventListener('click', () => app.dl.ctaClick(link.innerText, { location: header.innerText }));
        } 
      });
    }
  },

  featuredProduct: {
    els: document.querySelectorAll('.mt-featured-product'),

    init: function() {
      const _this = this;
      if (_this.els.length === 0) return;

      _this.els.forEach(el => {
        // Additional DL events
        const title = el.querySelector('.mt-featured-product__header');
        const link = el.querySelector('.mt-featured-product__action .mt-btn');
        if (title && link) {
          link.addEventListener('click', () => app.dl.ctaClick(link.innerText, { location: title.innerText }));
        }
      });
    }
  },

  lightbox: {
    el: {
      triggers: document.querySelectorAll('[data-lity]'),
      modal: document.querySelector('.mt-modal--lightbox'),
      modalContent: document.querySelector('.mt-modal--lightbox .mt-modal__content')
    },

    getYtVideoId: function (url = null) {
      if (url === null) return;
      const urlObj = new URL(url);
      if (urlObj.host === 'youtu.be') {
        return urlObj.pathname.replace('/', '');
      } else {
        return urlObj.searchParams.get('v');
      }
    },
  
    init: function () {
      const _this = this;
      _this.el.triggers = document.querySelectorAll('[data-lity]');
  
      if (_this.el.triggers.length === 0) return;
  
      _this.el.triggers.forEach(trigger => {
        if (trigger.dataset.lity === 'true') return;
  
        const targetUrl = trigger.href || trigger.dataset.href || '';
        let targetType = targetUrl.includes('.mp4') ? 'video' : 'unknown';
        if (targetUrl.includes('youtube.com') || targetUrl.includes('youtu.be')) {
          targetType = 'youtube';
        }
  
        if (targetType === 'video') {
          const videoTag = document.createElement('video');
          videoTag.src = targetUrl;
          videoTag.volume = 0.2;
          videoTag.setAttribute('playsinline', '');
          videoTag.setAttribute('controls', '');
          videoTag.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback noplaybackrate');
          let videoRatio = null;
  
          trigger.addEventListener('mouseenter', () => {
            videoTag.load();
            videoTag.addEventListener('loadedmetadata', () => {
              videoRatio = `${videoTag.videoWidth} / ${videoTag.videoHeight}`;
            });
          }, { once: true });
  
          trigger.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
            if (e.target.classList.contains('mt-activity-banner__close') || e.target.closest('.mt-activity-banner__close')) return;
  
            _this.open({ type: 'video', content: videoTag, videoRatio });
          });
        }
  
        if (targetType === 'youtube') {
          const videoId = _this.getYtVideoId(targetUrl);
  
          trigger.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
  
            _this.open({ type: 'youtube', content: videoId });
          });
        }
  
        trigger.dataset.lity = 'true';
      });
    },
  
    open: function ({ type, content, videoRatio = null }) {
      const _this = this;
  
      _this.el.modalContent.innerHTML = '';
  
      if (type === 'video') {
        const videoTag = content;
  
        if (videoRatio !== null) {
          _this.el.modalContent.style.setProperty('--video-ratio', videoRatio);
        } else {
          videoTag.load();
          videoTag.addEventListener('loadedmetadata', () => {
            const ratio = `${videoTag.videoWidth} / ${videoTag.videoHeight}`;
            _this.el.modalContent.style.setProperty('--video-ratio', ratio);
          });
        }
  
        _this.el.modalContent.appendChild(videoTag);
        app.modal.open(_this.el.modal);
        videoTag.play();
      }
  
      if (type === 'youtube') {
        const playerWrapper = document.createElement('div');
        playerWrapper.classList = 'video-wrapper';
  
        const player = document.createElement('div');
        player.id = 'yt-lightbox';
  
        playerWrapper.appendChild(player);
        _this.el.modalContent.appendChild(playerWrapper);
  
        const ytPlayer = new YT.Player(player, {
          height: '360',
          width: '640',
          host: 'https://www.youtube-nocookie.com',
          videoId: content,
          playerVars: { 
            autoplay: 1, 
            rel: 0,
            origin: window.location.host
          }
        });
  
        document.addEventListener('mt-lightbox-closed', () => {
          ytPlayer && ytPlayer.stopVideo();
        }, { once: true });
  
        app.modal.open(_this.el.modal);
      }
    }
  },

  klaviyo: {
    _learnq: window._learnq || [],
    klAjax: true,

    init: function () {
      const _this = this;
      
      // Popups
      const popups = {
        '#kl-popup': ['SskRuJ', 'SskRuJ'],
        '#kl-sms-popup': ['UvBL6E', 'UvBL6E'],
        '#kl-popup-uk': ['UvBL6E', 'UvBL6E'],
        '#kl-sn-popup': ['UvBL6E', 'UvBL6E'],
        '#kl-ds-popup': ['SskRuJ', 'SskRuJ'],
        '#kl-ds-sms-popup': ['UvBL6E', 'UvBL6E'],
        '#kl-ds-popup-uk': ['UvBL6E', 'UvBL6E'],
        '#kl-ds-sn-popup': ['UvBL6E','UvBL6E']
      };
      Object.entries(popups).forEach(entry => {
        const [trigger, modalId] = entry;
        const links = document.querySelectorAll(`[href="${trigger}"]`);
        links.forEach(link => {
          link.addEventListener('click', e => {
            e.preventDefault();
            const [desktopId, mobileId] = modalId;
            const formId = (window.innerWidth >= 768) ? desktopId : mobileId;
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(['openForm', formId]);
          });
        });
      });

      // Newsletter signup
      const footerForm = document.querySelector('#footer-newsletter');
      const formEmail = footerForm?.querySelector('input[name="contact[email]"]');
      if (footerForm && formEmail) {
        footerForm.addEventListener('submit', () => {
          _this._learnq.push(['identify', { '$email' : formEmail.value }]);
        });
      }
    }
  },

  gorgias: {
    init: function () {
      const links = document.querySelectorAll('[href="#chat"]');
      if (links.length === 0) return;

      links.forEach(link => {
        link.addEventListener('click', e => {
          e.preventDefault();
          window.GorgiasChat && window.GorgiasChat.open();
        });
      });
    }
  },

  vwo: {
    data: {
      tcb: 'control' 
    },

    event: (name = '', data = {}) => {
      if (name === '') return;

      window.VWO = window.VWO || [];
	    VWO.event = VWO.event || function () {VWO.push(["event"].concat([].slice.call(arguments)))};
      VWO.event(name, data);
    },

    testCollectionByok: function() {
      const _this = this;
      const removeSlide = (id = null) => {
        const section = document.querySelector('.mt-featured-collection');
        const sliders = document.querySelectorAll('.mt-featured-collection__list .swiper:not(.vwo-updated)');

        if (!section || id === null) return;
        sliders.forEach(function(slider) {
          const list = slider.closest('.mt-featured-collection__list');
          const slides = slider.querySelectorAll('.swiper-slide');
          let slidesCount = list.dataset.slides;
          if (slides[id]) slides[id].remove();
          list.dataset.slides = Number(slidesCount) - 1;
          slider.classList.add('vwo-updated');
          window.app.featuredCollection.init();
        });
      };
      let tcbUpdated = false;

      // Observer
      const tcbEl = document.querySelector(".mt-featured-collection");
      const tcbObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (entry.target.classList.contains('mt-featured-collection') && tcbUpdated == false) {
              (_this.data.tcb === 'control') ? removeSlide(1) : removeSlide(2);
              tcbUpdated = true;
              tcbObserver.unobserve(entry.target);
            }
          }
        });
      }, { threshold: 0 });
      tcbEl && tcbObserver.observe(tcbEl);
    },

    init: function() {
      //this.testCollectionByok();
    }
  },

  dl: {
    eventElements: document.querySelectorAll('.mt-slim-banner__button, .text-on-media .mt-btn, .persona-card, .mt-collection-card a, .mt-category a, .category-nav__item'),
    mainCategories: ['Bundles', 'Kits', 'Accessories', 'Reactive Intelligence Wall™'],

    sanitize(val) {
      if (typeof val === 'string') return val.replace(/\s+/g, ' ').trim();
      if (val && typeof val === 'object' && !Array.isArray(val)) {
        return Object.fromEntries(Object.entries(val).map(([k, v]) => [k, this.sanitize(v)]));
      }
      return val;
    },

    addedToCart(...productsJson) {
      if (productsJson.length === 0) return;

      const _this = this;
      const productsData = [];

      productsJson.forEach(json => {
        if (!json) return;
        const product = JSON.parse(json);
        const matchedCategories = _this.mainCategories.filter(category => product.categories.includes(category));
        const category = (matchedCategories.length > 0) ? matchedCategories[0] : 'All';
        
        const productData = {
          id: product.sku,
          name: product.title,
          brand: product.vendor,
          category: category,
          variant: product.variant,
          price: String(product.price),
          quantity: String(product.quantity),
          product_id: String(product.id),
          variant_id: String(product.variant_id)
        };

        if (product.upsell) {
          productData.upsell = 'pdp_addon';
        }

        productsData.push(productData);
      });

      if (productsData.length === 0) return;

      const collection = productsData[0] ? JSON.parse(productsJson[0])?.collection : '';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'cm_add_to_cart',
        feedLabel: window.Shopify.feedLabel,
        ...(collection && { collection_name: this.sanitize(collection) }),
        ecommerce: {
          currencyCode: window.Shopify.currency.active,
          add: {
            products: productsData
          }
        }
      });
    },

    blogStickyBannerClick(text = '') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'blog_sticky_banner_click',
        link_text: this.sanitize(text)
      });
    },

    blogRelatedArticleClick(text = '') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'blog_related_post_click',
        link_text: this.sanitize(text)
      });
    },

    blogRelatedProductClick(text = '') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'blog_related_product_click',
        link_text: this.sanitize(text)
      });
    },

    emailSignUp(email = null, location = null) {
      if (email === null || location === null) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'email_signup',
        email: this.sanitize(email),
        location: this.sanitize(location)
      });
    },
    
    menuClick(page = null, params = {}) {
      if (page === null) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'menu_click',
        link_text: this.sanitize(page),
        ...this.sanitize(params)
      });
    },

    menuHover(page = null, params = {}) {
      if (page === null) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'menu_hover',
        link_id: this.sanitize(page),
        ...this.sanitize(params)
      });
    },

    menuOpen(params = {}) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'menu_open',
        ...this.sanitize(params)
      });
    },

    click(text = '', params = {}) {
      const eventData = { event: 'click', ...this.sanitize(params) };
      (text !== '') && (eventData.link_text = this.sanitize(text));
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(eventData);
    },

    customClick(text = '', params = {}) {
      const eventData = { event: 'custom_click', ...this.sanitize(params) };
      (text !== '') && (eventData.link_text = this.sanitize(text));
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(eventData);
    },

    ctaClick(text = '', params = {}) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'cta_click',
        link_text: this.sanitize(text),
        ...this.sanitize(params)
      });
    },

    contentCardClick(page = null) {
      if (page === null) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'content_card_click',
        link_text: this.sanitize(page)
      });
    },

    tileInteraction(text = null) {
      if (text === null) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'tile_interaction',
        link_text: this.sanitize(text)
      });
    },

    selectItem(productJson = null, list_name = '') {
      if (productJson === null) return;

      const _this = this;
      const product = JSON.parse(productJson);
      const matchedCategories = _this.mainCategories.filter(category => product.categories.includes(category));
      const category = (matchedCategories.length > 0) ? matchedCategories[0] : 'All';

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'select_item',
        ...(product.collection && { collection_name: this.sanitize(product.collection) }),
        ecommerce: {
          items: [{
            item_name: product.title,
            item_product_id: String(product.id),
            item_variant_id: String(product.variant_id),
            item_id: product.sku,
            item_brand: product.vendor,
            item_category: category,
            item_variant: product.variant,
            item_list_name: list_name,
            quantity: '1'
          }]
        }
      });
    },

    viewItem(productJson = null) {
      if (productJson === null) return;
      
      const _this = this;
      const product = JSON.parse(productJson);
      const matchedCategories = _this.mainCategories.filter(category => product.categories.includes(category));
      const category = (matchedCategories.length > 0) ? matchedCategories[0] : 'All';

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "dl_view_item",
        feedLabel: window.Shopify.feedLabel,
        ecommerce: {
          currencyCode: window.Shopify.currency.active,
          detail: {
            products: [
              {
                id: product.sku,
                name: product.title,
                brand: product.vendor,
                category: category,
                variant: product.variant,
                price: String(product.price),
                quantity: String(product.quantity),
                product_id: String(product.id),
                variant_id: String(product.variant_id)
              }
            ]
          }
        }
      });
    },

    init: function() {
      const _this = this;
      const collectionName = _this.sanitize(document.querySelector('.mt-collection-header')?.dataset.collection || '');
      _this.eventElements.forEach(el => {
        if (el.closest('.mt-slim-banner')) {
          const section = el.closest('.mt-slim-banner')?.querySelector('.mt-slim-banner__header');
          const locationText = section ? section.innerText : 'Build Your Own Kit Banner';
          el.addEventListener('click', () => _this.ctaClick(el.innerText, { location: locationText, ...(collectionName && { collection_name: collectionName }) }));
        }
        if (el.closest('.text-on-media')) {
          const section = el.closest('.text-on-media')?.querySelector('.text-on-media__header');
          const locationText = section ? section.dataset.text : '';
          el.addEventListener('click', () => _this.ctaClick(el.dataset.text, { location: locationText }));
        }
        if (el.classList.contains('persona-card')) {
          const label = el.querySelector('.persona-card__label');
          label && el.addEventListener('click', () => _this.ctaClick(label.dataset.text, { location: '' }));
        }
        if (el.closest('.mt-category')) {
          const card = el.closest('.mt-category');
          const locationText = card.closest('.mt-collection')?.querySelector('.mt-collection__heading')?.innerText || '';
          const linkText = card.querySelector('.mt-category__title')?.innerText || '';
          el.addEventListener('click', () => _this.customClick(linkText, { location: locationText, ...(collectionName && { collection_name: collectionName }) }));
        }
        if (el.closest('.mt-collection-card')) {
          const card = el.closest('.mt-collection-card');
          const locationText = card.querySelector('.mt-collection-card__title')?.innerText || '';
          const linkText = el.querySelector('.mt-btn__inner')?.innerText || el.innerText;
          el.addEventListener('click', () => {

            _this.ctaClick(linkText, { location: locationText, ...(collectionName && { collection_name: collectionName }) });
          });
        }
        if (el.closest('.category-nav')) {
          const label = el.querySelector('.category-nav__label');
          el.addEventListener('click', () => _this.ctaClick(
            label?.innerText || '',
            { location: 'Category nav', ...(collectionName && { collection_name: collectionName }) }
          ));
        }
      });
    }
  },

  init: function () {
    this.footer.init();
    this.footer.initV2();
    this.form.init();
    this.productForm.init();
    this.productItem.init();
    this.cart.init();
    this.collection.init();
    this.animation.init();
    this.textImage.init();
    this.featuredProduct.init();
    this.lightbox.init();
    this.header.init();
    this.utilities.validateMarketCatalog();
    this.discounts.init();
    this.video.init();
    this.newsletter.init();
    this.dl.init();
    this.prefetch.init();
    this.klaviyo.init();
    this.gorgias.init();
    this.vwo.init();
  }
};
window.app = app;
window.addEventListener('DOMContentLoaded', () => app.init());
document.addEventListener('mt-reinit-lity', () => app.lightbox.init());

// Youtube API Support
const ytLityElements = document.querySelectorAll('[data-lity][href*="youtube"], [data-lity][href*="youtu.be"], .yt-player');
if (ytLityElements.length > 0) {
  const tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}
window.ytApiLoaded = false;
function onYouTubeIframeAPIReady() {
  window.ytApiLoaded = true;
  document.dispatchEvent(new CustomEvent('yt-api-loaded', {}));
}